import React, { useEffect, useState } from "react";

const SummaryTable = ({ getData }) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    const data = getData();
    const allValues = data.getFieldValues();
    const allTags = data.getFieldTags();

    let result = {};

    Object.entries(allValues).forEach(([id, value]) => {
      const tag = allTags[id];
      result[tag] = value;
    });

    setValues(result);
  }, []);

  // Helper to append default value if value doesn't exist
  const getValue = (tag) => getData().getFieldValue(tag) || "";

  return (
    <div>
      <div className="custom__summarytable">
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">Name</div>
          <div className="custom__summarytable__row__content">
            {getValue("firstName")} {getValue("lastName")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">D.O.B</div>
          <div className="custom__summarytable__row__content">
            {getValue("dateOfBirth")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">Email</div>
          <div className="custom__summarytable__row__content">
            {getValue("email")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">Mobile</div>
          <div className="custom__summarytable__row__content">
            {getValue("mobile")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">
            Current Address
          </div>
          <div className="custom__summarytable__row__content">
            {getValue("currentAddress")?.address ?? ""}
            <br />
            {getValue("currentAddress")?.suburb ?? ""}
            <br />
            {getValue("currentAddress")?.state ?? ""}&nbsp;
            {getValue("currentAddress")?.postcode ?? ""}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">
            Permanent resident or citizen
          </div>
          <div className="custom__summarytable__row__content">
            {getValue("isCitizenOrPermanentResident")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">Described as</div>
          <div className="custom__summarytable__row__content">
            {getValue("whatBestDescribesYou")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">Joint account</div>
          <div className="custom__summarytable__row__content">
            {getValue("isJointAccount")}
          </div>
        </div>
        <div className="custom__summarytable__row">
          <div className="custom__summarytable__row__label">
            Product selected
          </div>
          <div className="custom__summarytable__row__content">
            {getValue("selectedProduct")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryTable;
